export const WHATSAPP_URL =
  "https://wa.me/552120381079?text=Ol%C3%A1%2C%20conheci%20a%20EXEKUTA%20pelo%20site%20e%20gostaria%20de%20solicitar%20um%20diagn%C3%B3stico%20de%20SEO.";

export const PHONE = "+55 21 2038-1079";

export const SERVICES = [
  {
    id: "desenvolvimento",
    num: "01",
    title: "Desenvolvimento",
    tagline: "Presença digital construída para crescer.",
    items: [
      {
        title: "Criação de Sites",
        desc: "Sites profissionais, institucionais e WordPress com estratégia, performance e estrutura preparada para aquisição.",
      },
      {
        title: "Landing Pages",
        desc: "Páginas de conversão com mensagem, experiência e mensuração conectadas a uma ação de negócio.",
      },
      {
        title: "Lojas Virtuais / E-commerce",
        desc: "E-commerce com arquitetura comercial, experiência, performance e base técnica preparada para aquisição e crescimento.",
      },
    ],
  },
  {
    id: "marketing",
    num: "02",
    title: "Marketing & Performance",
    tagline: "Aquisição e dados com direção.",
    items: [
      {
        title: "Gestão de Tráfego Pago",
        desc: "Campanhas pagas com estratégia, rastreamento e otimização para transformar investimento em demanda qualificada.",
      },
      {
        title: "Marketing Digital",
        desc: "Estratégia digital que organiza canais, conteúdo, aquisição e mensuração em torno de objetivos claros de negócio.",
      },
      {
        title: "Analytics e Performance",
        desc: "Monitoramento, relatórios e ciclos de melhoria conectados a indicadores.",
      },
    ],
  },
  {
    id: "seo",
    num: "03",
    title: "SEO & Google",
    tagline: "Visibilidade com estrutura, relevância e intenção.",
    items: [
      {
        title: "Estratégia SEO",
        desc: "Diagnóstico, pesquisa e priorização para definir onde competir e por quê.",
      },
      {
        title: "SEO Técnico",
        desc: "Rastreamento, indexação, arquitetura, performance e integridade técnica.",
      },
      {
        title: "SEO On-Page",
        desc: "Conteúdo, estrutura semântica, intenção de busca e otimização de páginas.",
      },
      {
        title: "SEO Local",
        desc: "Presença regional, consistência de dados e descoberta em buscas próximas.",
      },
      {
        title: "Autoridade Digital",
        desc: "Conteúdo, reputação e aquisição ética de relevância para fortalecer confiança.",
      },
    ],
  },
  {
    id: "automacao",
    num: "04",
    title: "Automação & IA",
    tagline: "Processos digitais com menos atrito.",
    items: [
      {
        title: "Automação & IA",
        desc: "Automação, inteligência artificial e integrações para reduzir tarefas manuais, organizar dados e acelerar processos comerciais.",
      },
    ],
  },
  {
    id: "suporte",
    num: "05",
    title: "Suporte & Infraestrutura",
    tagline: "Continuidade, velocidade e segurança.",
    items: [
      {
        title: "Manutenção & Performance",
        desc: "Manutenção técnica, velocidade, segurança, backup e monitoramento para manter o site estável e pronto para performar.",
      },
    ],
  },
];

export const METHOD = [
  {
    num: "01",
    title: "Diagnóstico",
    desc: "Leitura profunda do cenário: dados, técnica, conteúdo e concorrência para entender onde você está.",
  },
  {
    num: "02",
    title: "Estratégia",
    desc: "Priorização e documentação para definir onde competir, por quê e em qual ordem.",
  },
  {
    num: "03",
    title: "Execução",
    desc: "Implementação técnica, on-page e de conteúdo no mesmo fluxo da análise.",
  },
  {
    num: "04",
    title: "Monitoramento",
    desc: "Acompanhamento contínuo de indicadores para validar cada ação.",
  },
  {
    num: "05",
    title: "Escala",
    desc: "Leitura dos resultados, evolução e ampliação do que funciona.",
  },
];

export const VALUES = [
  { title: "Clareza", desc: "Nada de abstração: leitura de cenário e priorização explícitas." },
  { title: "Responsabilidade", desc: "Acompanhamento responsável do início ao fim do ciclo." },
  { title: "Profundidade", desc: "Análise profunda antes de qualquer entrega." },
  { title: "Execução", desc: "Execução técnica no mesmo fluxo do planejamento." },
  { title: "Evolução", desc: "Ciclos contínuos de leitura, ajuste e crescimento." },
  { title: "Transparência", desc: "Documentação e acompanhamento abertos em cada etapa." },
];

export const FAQ = [
  {
    q: "Como funciona o início de um projeto?",
    a: "Começamos com um diagnóstico: leitura de cenário, dados e prioridades. A estratégia só é proposta depois que o contexto está claro.",
  },
  {
    q: "SEO leva quanto tempo para gerar resultados?",
    a: "SEO é um crescimento construído: os primeiros movimentos acontecem na estrutura técnica e de conteúdo, e os resultados se consolidam com execução contínua e monitoramento.",
  },
  {
    q: "Vocês atuam apenas com SEO?",
    a: "Não. Além de SEO & Google, atuamos em desenvolvimento, tráfego pago, marketing digital, analytics, automação & IA e manutenção & performance.",
  },
  {
    q: "Como é feito o acompanhamento dos resultados?",
    a: "Com monitoramento, relatórios e ciclos de melhoria conectados a indicadores de negócio — cada ação com um papel definido dentro de uma arquitetura e jornada.",
  },
  {
    q: "Como solicito um diagnóstico?",
    a: "Pelo formulário da página de contato ou direto pelo WhatsApp. Conte o contexto: a resposta começa por entender problema, prioridade e capacidade de execução.",
  },
];

export const INSIGHTS = [
  {
    title: "SEO local: como organizar presença, relevância e confiança",
    url: "https://exekuta.com.br/seo-local/",
    category: "SEO",
    author: "EXEKUTA",
  },
  {
    title: "SEO técnico: o que priorizar antes de produzir mais conteúdo",
    url: "https://exekuta.com.br/seo-tecnico/",
    category: "SEO",
    author: "EXEKUTA",
  },
  {
    title: "Como funciona uma estratégia de SEO conectada ao negócio",
    url: "https://exekuta.com.br/estrategia-seo-conectada-ao-negocio/",
    category: "SEO",
    author: "EXEKUTA",
  },
];

export const IMAGES = {
  founder:
    "https://images.unsplash.com/photo-1640531005390-38bd92755d6a?crop=entropy&cs=srgb&fm=jpg&q=85",
  analytics1:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85",
  analytics2:
    "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&q=85",
  analytics3:
    "https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86?crop=entropy&cs=srgb&fm=jpg&q=85",
  studio1:
    "https://images.unsplash.com/photo-1641060272821-df59e2c0b5ed?crop=entropy&cs=srgb&fm=jpg&q=85",
  studio2:
    "https://images.unsplash.com/photo-1548123325-525b8e0cde7c?crop=entropy&cs=srgb&fm=jpg&q=85",
};
